import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Summary from "../ControlPanel/Summary/Summary";
import PriceBook from "../ControlPanel/Summary/PriceBook.jsx";
import { useDispatch, useSelector } from "react-redux";
import { handleShowsummarymodal, handleShowComparePriceModal, publicEditFun, setManufacturer } from '../../action/index';


const SummaryModal = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [isShowPriceBook, setIsShowPriceBook] = useState(false);
  const [delayedShow, setDelayedShow] = useState(false);
  const [showPriceDetail, setShowPriceDetail] = useState(false);
  const dispatch = useDispatch();
  const props = useSelector((state) => state.reducer);
  const isLTBuilding = useSelector((state) => state.reducer.const_var.isLTBuilding);
  
  
  const handleTabSelect = (tabIndex) => {
    setSelectedTab(tabIndex);
    setIsShowPriceBook(false);
  };

  const handleCompare = (val) => {
    if (props.const_var.is_loader == false) {
      props.const_var.ComparisionDataArray = {};
      dispatch(handleShowsummarymodal());
      dispatch(handleShowComparePriceModal())
    }
  }
  const custom = () => {
    document.getElementsByClassName("modal")[0].style.transform = "translate(-100%, 0)"
    document.getElementsByClassName("modal")[0].style.transition = "all 1.2s ease-in-out"
    setTimeout(() => {
      dispatch(handleShowsummarymodal());
      setIsShowPriceBook(false);
      setSelectedTab(0);
      setShowPriceDetail(false);
    }, 300)
  }

  useEffect(() => {
    if (window.innerWidth < 1024) {
      if (props.isShowSummaryModal) {
        setTimeout(() => {
          dispatch(handleShowsummarymodal());
        }, 700);
      }
    }
  }, [window.innerWidth]);

  useEffect(() => {
    if (!isShowPriceBook && selectedTab === 0) {
      const timer = setTimeout(() => {
        setDelayedShow(true);
      }, 800);
      return () => clearTimeout(timer);
    } else {
      setDelayedShow(false);
    }
  }, [isShowPriceBook, selectedTab]);

  // useEffect(() => {
  //   setShowPriceDetail(selectedTab === 1)
  // }, [])
  const isLogin = props.const_var.loginSession;
  const hideCompareOption = props.const_var.hideCompareOption && !isLogin;
  const isCustomBuilding = props.const_var.b_o_J_1[props.params.p_b_t] == "Custom Buildings" && !isLogin;
  const isMFGLoading = props.const_var?.comparisionLoadermfg1 || props.const_var?.comparisionLoadermfg2

  const { crmSetting, selectedTabstate, loginSession, is_quote_Edit ,is_intel} = props.const_var;
  let selectedComparePriceDataForNonLoggedIn = [];
  if (!loginSession && selectedTabstate != "statechange" && props.nonLoggedInpriceCompareData) {
    const key = `selectedState_${props.params.p_s_n}`
    selectedComparePriceDataForNonLoggedIn = props.nonLoggedInpriceCompareData[key];
  }
  const isInventoryModule = crmSetting.is_module_name === 'inventory';
  const isTabStateChange = selectedTabstate === 'statechange' || selectedTabstate === 'buildstyle' || selectedTabstate === 'loginstyletab';
  const isConditionsMet = (isInventoryModule || is_quote_Edit === true);
  const isNonLoggedInWithComparePriceData = selectedComparePriceDataForNonLoggedIn?.length > 0 && !loginSession && selectedTabstate != 'statechange';
  const showCompare = isInventoryModule && isTabStateChange && !isNonLoggedInWithComparePriceData
    ? true : isConditionsMet && !isNonLoggedInWithComparePriceData ? true : false;
    
    let isCompareExsist = true
    if(!props.const_var.loginSession && props.const_var.stateManufacturerAcordingAPI && Object.keys(props.const_var.stateManufacturerAcordingAPI).length > 0 && props.params.p_s_n){
      isCompareExsist=props.const_var?.stateManufacturerAcordingAPI?.[props.params.p_s_n]?.price_comparision?.length > 0 &&  props.const_var?.stateData?.hide_price_calculation == 0  ? true : false;
    }
    if(props.const_var.loginSession && props.params.p_s_n && props.const_var.stateManufacturerAcordingAPI && props.const_var.stateManufacturerAcordingAPI[props.params.p_s_n] != undefined && props.const_var.stateManufacturerAcordingAPI[props.params.p_s_n].length < 2) {
      isCompareExsist = false
    }
  return (
    <div>
      <Modal
        show={props.isShowSummaryModal}
        backdrop="static"
        keyboard={false}
        onHide={handleShowsummarymodal}
        dialogClassName="summary-modal"
        backdropClassName="ract-modal-pre-parent"
        style={{overflow: 'hidden', zIndex: props.const_var.isShowAlert == true && props.const_var.alertUsedFor == "NoMfgExsist" ? 1 : 1050}}
      >
        <div className="summary-price-wrapper">
          <div className="summary-wrapper">
            <div className="summary-modal-header">
              <div className="summary-header">
                <h6
                  onClick={() => {
                    handleTabSelect(0);
                    setTimeout(() => {
                      setShowPriceDetail(false)
                    }, 100);
                  }
                  }
                  className={selectedTab === 0 ? "selected-tab" : ""}
                >
                  Product Summary
                </h6>
                {
                 ! is_intel &&
                <>
                {!isLTBuilding && !hideCompareOption && !isCustomBuilding && !props.const_var.checkmoreCustomizeFlag && !showCompare && isCompareExsist &&
                  <h6
                    onClick={() => {
                      setIsShowPriceBook(false);
                      handleCompare(this)
                    }
                    }
                    className={selectedTab === 1 ? "selected-tab" : ""}
                  >
                    Compare Price
                  </h6>
                }
                </>
                 }
              </div>
              <button
                disabled={isMFGLoading}
                className="close"
                onClick={custom}
              >
                <span className="icon-close"></span>
              </button>
              {props.const_var.loginSession == true && props.priceBookFile.length>0 &&
                <div
                  className="price-book"
                  onClick={() => setIsShowPriceBook(true)}
                  style={{ opacity: delayedShow ? 1 : 0 }}
                >
                  <span>Price Book</span>
                  <i className="icon-double-arrow-ico"></i>
                </div>
              }
            </div>
            {props.const_var.crmSetting.is_quote_Edit == true ? (
              <div className="summary-alert">
                <div className="summary-alert-text">
                  Please note that any changes made to the building may result in
                  price variations in the initial quote. Once saved this change
                  request will be submitted to your sales contact for review.
                </div>
                <button
                  id="save_update_orderquote_automation"
                  onClick={(e) => {
                    dispatch(publicEditFun(props.const_var.isPublicEdit, ""));
                  }}
                  className=" btn  btn-small btn-customer-edit btn-primary summary-alert-btn"
                >
                  <span className="saving-effect saving-effect-type-2">
                    <span></span>
                    <span></span>
                    <span></span>
                  </span>
                  <span className="edge"></span>
                  <div className="front">
                    <span className="icon icon-content"></span>
                    <span className="text ">Edit Configuration</span>
                  </div>
                </button>
              </div>
            ) : null}
            <div className="summary-modal-body">
              <div id="summary-container" style={{ display: selectedTab === 0 ? 'block' : 'none' }}>
                <Summary showPriceDetail={showPriceDetail} />
              </div>



            </div>
          </div>

          {
            // selectedTab === 0 ?
              <div
                className="price-book-wrapper"
                style={{ transition: isShowPriceBook ? 'transform 0.8s ease-in-out, z-index 1.5s ease-in-out' : 'transform 0.8s ease-in-out, z-index 0s ease-in-out', transform: isShowPriceBook ? "translate(0, 0)" : "translate(-110%, 0)", zIndex: isShowPriceBook ? 0 : -1 }}
              >
                {props.const_var.loginSession == true &&
                  <><PriceBook setIsShowPriceBook={setIsShowPriceBook} /></>
                }
              </div>
              // :
              // <>
              //   {!props.const_var.loginSession ? (
              //     <PriceDetailNonLoggedIn
              //       show={showPriceDetail}
              //       startAnimation={startAnimation}
              //       handleStartAnimation={handleStartAnimation}
              //       loading={loading}
              //     />
              //   ) : (
              //     <PriceDetail
              //       show={showPriceDetail}
              //       startAnimation={startAnimation}
              //       handleStartAnimation={handleStartAnimation}
              //       loading={loading}
              //     />
              //   )}
              // </>
          }
        </div>
      </Modal>
    </div>
  );
};

export default SummaryModal;